
/**
 * PeriodFrame defines the startind and ending time points of a winning period.
 *
 * @typedef PeriodFrame
 * @type {Object}
 * @property {startTime} StartTime the starting time point
 * @property {endTime} EndTime the ending time point
 * @property {isTimeInSec} IsTimeInSec if the time is displayed in sec
 */

export class PeriodFrame {

    startTime: string
    endTime?: string
    isTimeInSec?: boolean

    constructor(source: PeriodFrame) {
        this.startTime = source.startTime;
        this.endTime = source.endTime;
        this.isTimeInSec = source.isTimeInSec;
    }
}